<!-- <nb-tabset fullWidth>
    <nb-tab tabTitle="All">
        <div class="label-value-input slider">
            <div class="element-label minor">
                <div class="input-label">Units:</div>
                <div class="input-value-container">
                    <nb-select [(selected)]="selectedUom" [placeholder]="selectedUom"  (selectedChange)="changeUom($event)" size="tiny" #narrowSelect>
                        <nb-option *ngFor="let uom of uoms" [value]="uom">{{ uom.name }}</nb-option>
                    </nb-select>
                </div>
            </div>
            <div class="element-label">
                <div class="input-label">Width:</div>
                <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
            </div>
            <div class="custom-slider element-value">
                <ngx-slider [options]="options" [formControl]="sliderControl"></ngx-slider>
            </div>
            <div class="element-label minor">
                <div class="input-label">Style:</div>
                <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
            </div>
            <ng-container *ngIf="field.type == 'border'">
            <div class="element-label minor">
                <div class="input-label">Radius:</div>
                <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
            </div>
            
                <div class="element-label minor twitter-color" kwTwitterColor>
                    <color-twitter
                        [color]="color"
                        [colors]="colors"
                        triangle="top-right"
                        (onChangeComplete)="changeComplete($event)"
                        (onChange)="changeComplete($event)"
                    ></color-twitter>
                </div>
            </ng-container>
        </div>
    </nb-tab>
</nb-tabset> -->
<div class="label-value-input slider">
    <div class="element-label minor">
        <div class="input-label">Units:</div>
        <div class="input-value-container">
            <nb-select [(selected)]="selectedUom" [placeholder]="selectedUom"  (selectedChange)="changeUom($event)" size="tiny" #narrowSelect>
                <nb-option *ngFor="let uom of uoms" [value]="uom">{{ uom.name }}</nb-option>
            </nb-select>
        </div>
    </div>
    <div class="element-label">
        <div class="input-label">{{field.type | titlecase}}</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
    </div>
    <div class="custom-slider element-value">
        <ngx-slider #valueSlider [options]="options" [formControl]="sliderControl" (userChange)="sliderUserChange($event)" (userChangeStart)="sliderUserChangeStart($event)" (userChangeEnd)="sliderUserChangeEnd($event)"></ngx-slider>
    </div>
    <div class="element-label minor">
        <div class="input-label">Top:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueTop" (ngModelChange)="onIndividualValueChange()"></div>
    </div>
    <div class="element-label minor">
        <div class="input-label">Right:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueRight" (ngModelChange)="onIndividualValueChange()"></div>
    </div>
    <div class="element-label minor">
        <div class="input-label">Bottom:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueBottom" (ngModelChange)="onIndividualValueChange()"></div>
    </div>
    <div class="element-label minor">
        <div class="input-label">Left:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueLeft" (ngModelChange)="onIndividualValueChange()"></div>
    </div>
    <!-- <div class="element-label minor">
        <div class="multi-inputs">
            <div class="label-row">
                <div>ALL</div>
                <div>T</div>
                <div>R</div>
                <div>B</div>
                <div>L</div>
            </div>
            <div class="input-row">
                <div>
                    <input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll">
                </div>
                <div>
                    <input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll">
                </div>
                <div>
                    <input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll">
                </div>
                <div>
                    <input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll">
                </div>
                <div>
                    <input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll">
                </div>
            </div>
        </div>
        <div class="input-label">All:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
    </div> -->

    <!-- <ng-container *ngIf="field.type == 'border'">
    <div class="element-label minor">
        <div class="input-label">Radius:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
    </div>
</ng-container> -->
        <!-- <div class="element-label minor twitter-color" kwTwitterColor>
            <color-twitter
                [color]="color"
                [colors]="colors"
                triangle="top-right"
                (onChangeComplete)="changeComplete($event)"
                (onChange)="changeComplete($event)"
            ></color-twitter>
        </div> -->
    
</div>
<!-- <nb-tabset fullWidth>
    <nb-tab tabTitle="All">
        <div class="element-label">
            <div class="input-label">Width:</div>
            <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
        </div>
    </nb-tab>
    <nb-tab tabTitle="T">
        <div class="element-label">
            <div class="input-label">Width:</div>
            <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
        </div>
    </nb-tab>
    <nb-tab tabTitle="R">
        <div class="element-label">
            <div class="input-label">Width:</div>
            <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
        </div>
    </nb-tab>
    <nb-tab tabTitle="B">
        <div class="element-label">
            <div class="input-label">Width:</div>
            <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
        </div>
    </nb-tab>
    <nb-tab tabTitle="L">
        <div class="element-label">
            <div class="input-label">Width:</div>
            <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
        </div>
    </nb-tab>
</nb-tabset> -->
